<template>
    <b-modal @hidden="fecharModal" size="xl" hide-footer :title="prefix + title" v-model="showModal">

        <b-card class='mt-3' bg-variant="light">
            <b-form @submit.stop.prevent="submitForm">
                <b-row>
                    <b-col cols="6">
                        <LgFormInput labelclass='p-0' id="autorizacaoNumero" v-model="autorizacaoNumero" required
                            label="Autorização Número:*" :disabled="true" />
                    </b-col>
                    <b-col cols="6">
                        <LgFormInput labelclass='p-0' id="dataCriacao" v-model="dataCriacao" required
                            label="Data Criação:" :disabled="true" />
                    </b-col>


                </b-row>
                <b-row>
                    <b-col cols="6">

                        <LgFinderPageUnidadeAdministrativa :prefix="prefix + title" v-model="departamento"
                            @onselect="handleDepartamento" id="finderPageUnidadeAdministrativaConsultarAutorizacaoForm"
                            label="Departamento:*" :disabled="isViewMode" />
                    </b-col>

                    <b-col cols="6">
                        <LgFinderPagePessoa :disabled="isViewMode" id="finderResponsavelAutorizacao"
                            label="Resp.Autorização:*" @onselect="handlePessoaResponsavel" v-model="responsavel"
                            invalidFeedback=" " :prefix="prefix + title" />


                    </b-col>

                    <b-col md="6">
                        <LgFormTextarea description=" " labelclass='p-0' id="objeto" v-model="objeto" required
                            label="Objeto:*" :disabled="isViewMode" />
                    </b-col>
                    <b-col md='6'>
                        <LgFormTextarea description=" " labelclass='p-0' id="observacao" v-model="observacao" required
                            label="Observação:*" :disabled="isViewMode" />
                    </b-col>
                </b-row>
                <b-row>

                    <b-col cols="6">
                        <LgFinderPageRequisicoes :disabled="isViewMode" v-model="requisicao" :modalOnly='false'
                            label="Requisição:*" id='finderRequisicoesAutorizacao' :onlyAproved='true'
                            :prefix='[prefix + title]' ref="finderRequisicoesAutorizacao" @input="requisicaoSelect" />
                    </b-col>


                    <b-col cols='6'>
                        <LgFormInput labelclass='p-0' id="tipoRequisicaoCompra" v-model="tipoRequisicaoCompra"
                            label="Tipo Compra:" :disabled="true" />

                    </b-col>
                </b-row>
            </b-form>
        </b-card>
        <b-card class='mt-3' bg-variant="light">
            <b-tabs v-model="activeTab">
                <b-tab title="Itens">
                    <b-table :items="itens" :fields="itensFields"></b-table>
                </b-tab>
            </b-tabs>
        </b-card>
        <div class="d-flex justify-content-center mt-3">
            <b-button id="confirmarSalvar" @click="submitForm" variant="success" style="height: 30px" pill size="sm"
                :disabled="isViewMode">
                <div class="btn-size-alinhamento">
                    <b-icon icon="check-circle" />
                </div>
            </b-button>
            <b-button id="cancelarSalvar" class="ml-2" @click="fecharModal" style="height: 30px" pill size="sm"
                variant="danger">
                <div class="btn-size-alinhamento">
                    <b-icon icon="x-circle" />
                </div>
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import LgFinderPageRequisicoes from "@/components/Finders/LgFinderPageRequisicoes.vue"
import AutorizacaoCompraService from "@/core/api/AutorizacaoCompraService.js"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFormTextarea from "@/core/components/Form/LgFormTextarea.vue"
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue"
import ResourceService from "@/core/api/ResourceService";
import moment from "moment"
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";

export default {
    components: {
        LgFormInput,
        LgFormTextarea,
        LgFinderPageRequisicoes,
        LgFinderPageUnidadeAdministrativa,
        LgFinderPagePessoa
    },
    props: {

        prefix: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "Cadastrar"
        },
        idAutorizacao: {
            type: Number,
            default: null,
        },
        isViewMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showModal: true,
            requisicao: {},
            responsavel: {},
            dataCriacao: "",
            departamento: {},
            tipoRequisicaoCompra: "",
            autorizacaoNumero: "",
            descricao: "",
            justificativa: "",
            objeto: "",
            observacao: "",
            responsavelAutorizacao: "",
            requisicoes: [],
            itens: [],
            itensFields: [
                { key: 'descricaoResumida', label: 'Nome' },
                { key: 'quantidade', label: 'Quantidade' },
            ],
            activeTab: 0,
        }
    },
    async beforeMount() {
        this.$serviceRequisicoes = new ResourceService(`/api/requisicoes-compra`);
        this.$service = new ResourceService(`/api/autorizacao-compra`);

        if (this.idAutorizacao) {
            await this.loadAutorizacao(this.idAutorizacao)
        }
    },
    methods: {
        handleDepartamento(departamento) {
            this.departamento = departamento;
        },
        handlePessoaResponsavel(item) {
            this.responsavel = item;
        },
        async loadAutorizacao(id) {
            const response = await AutorizacaoCompraService.findById(id);
            const data = response.data;
            this.departamento = data.departamento;
            this.responsavel = data.responsavel;
            this.dataCriacao = moment(data.dataCriacao).format("DD-MM-YYYY HH:mm:ss");
            this.autorizacaoNumero = data.autorizacaoNumero;
            this.objeto = data.objeto;
            this.observacao = data.observacao;
            this.requisicoes = data.requisicoes || [];
            this.requisicao = data.requisicoes[0] ? data.requisicoes[0] : {};
            this.tipoRequisicaoCompra = this.requisicao.tipoRequisicaoCompra.descricao;

            this.itens = data.itens || [];
        },
        async submitForm() {

            if (!this.departamento || !this.departamento.id) {
                this.$notify({
                    message: 'Por favor, escolha um Departamento',
                    type: 'danger',
                    solid: true
                })
                return;
            }

            if (!this.responsavel || !this.responsavel.id) {
                this.$notify({
                    message: 'Por favor, escolha um responsável',
                    type: 'danger',
                    solid: true
                })
                return;
            }

            if (!this.objeto) {
                this.$notify({
                    message: 'Por favor, preencha o campo Objeto.',
                    type: 'danger',
                    solid: true
                })
                return
            }

            if (!this.observacao) {
                this.$notify({
                    message: 'Por favor, preencha o campo Observação.',
                    type: 'danger',
                    solid: true
                })
                return
            }

            if (this.requisicoes.length === 0) {
                this.$notify({
                    message: 'Por favor, adicione pelo menos uma requisição.',
                    type: 'danger',
                    solid: true
                })
                return
            }


            const data = {
                responsavel: this.responsavel,
                departamento: this.departamento,
                autorizacaoNumero: this.autorizacaoNumero,
                objeto: this.objeto,
                observacao: this.observacao,
                requisicoes: this.requisicoes,
                itens: this.itens
            }

            try {
                if (this.idAutorizacao) {
                    await AutorizacaoCompraService.update(this.idAutorizacao, data)
                } else {
                    await AutorizacaoCompraService.create(data)
                }
                this.$notify({
                    message: 'Autorização de compra salva com sucesso!',
                    title: 'Sucesso',
                    variant: 'success',
                    solid: true
                })
                this.fecharModal()
            } catch (error) {
                const errorMessage = error.response && error.response.data
                    ? error.response.data
                    : 'Erro ao salvar autorização.'
                this.$notify({
                    type: 'danger',
                    message: errorMessage
                })
                console.error("Erro ao salvar autorização de compra:", error)
            }
        },
        fecharModal() {
            this.$emit("close")
        },
        async requisicaoSelect(item) {
            this.requisicoes = [];
            this.requisicoes.push({id: item.id});
            this.tipoRequisicaoCompra = item.tipoRequisicaoCompra;
            item.tipoRequisicaoCompra = null;
            item.grupoProduto = null;
            this.requisicao = item;
            var { data } = await this.$serviceRequisicoes.get(`${item.id}/itens`);
            this.itens = data;
        },
    },
}

</script>

<style scoped></style>
